export default __webpack_public_path__ + "static/media/sneak-peek.14947d6c.svg";